import { createApiClient, ApiClient } from '../services/ApiClient';
import * as types from './ActionTypes';
import {history} from '../router';
import {MENTORS_URL} from '../router/urls';

export function setMentor(process_id: number, mentor: string){
  return (dispatch:any) =>{
    const api = createApiClient();
    api.setMentor(process_id, mentor, {
      success: async (response) => {
        dispatch({
          type: types.SET_MENTOR,
          payload: {
            process_id,
            mentor,
          }
        })
        dispatch(getMMProcessAll());
      }
    });
  }
}

export function setAllowDefence(process_id: number, allow: boolean){
  return (dispatch:any) =>{
    const api = createApiClient();
    api.setAllowDefence(process_id, allow, {
      success: async (response) => {
        dispatch({
          type: types.SET_MENTOR,
          payload: {
            process_id,
            allow,
          }
        })
        dispatch(getMentorProcessAll());
      }
    });
  }
}

export function getMMProcessAll() {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'mm-process'});
    api.getMMProcessAll({
      success: (response) => {
        dispatch({ type: types.FETCH_MM_PROCESS, payload: response });
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'mm-process' });
      }
    })
  }
}

export function getMentorProcessAll() {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'mentor-process'});
    api.getMentorProcessAll({
      success: (response) => {
        dispatch({ type: types.FETCH_MENTOR_PROCESS, payload: response });
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'mentor-process' });
      }
    })
  }
}

export function getSlaveMentorsAll() {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'slave-mentors'});
    api.getSlaveMentorsAll({
      success: (response) => {
        dispatch({ type: types.FETCH_SLAVE_MENTORS, payload: response });
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'slave-mentors' });
      }
    })
  }
}

export function acceptMentorProcess(process_id: string, accept: boolean, comment: string) {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'mentor-process'});
    api.acceptMentorProcess(process_id,  accept, comment,{
      success: (response) => {
        dispatch({type: types.LOADING_FINISH, payload: 'mentor-process'});
        dispatch(getMentorProcessAll());
        history.push(MENTORS_URL);
      },
      error: (e, response) => {
        if( response ){
          const result = JSON.parse(response);
          if(result && result.message){
            alert(result.message);
          }else alert(`API ERROR: ${e}`);
        }else{
          alert(`API ERROR: ${e}`);
        }
        dispatch({type: types.LOADING_FINISH, payload: 'mentor-process'});
      }
    })
  }
}
